import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enCommon from './locales/en/common.json'
import enAnalytics from './locales/en/analytics.json'
import enAuth from './locales/en/auth.json'
import enBalance from './locales/en/balance.json'
import enBills from './locales/en/bills.json'
import enCustomers from './locales/en/customers.json'
import enDisputes from './locales/en/disputes.json'
import enInvoices from './locales/en/invoices.json'
import enNotifications from './locales/en/notifications.json'
import enPayments from './locales/en/payments.json'
import enRefunds from './locales/en/refunds.json'
import enRooms from './locales/en/rooms.json'
import enSettings from './locales/en/settings.json'
import enShops from './locales/en/shops.json'
import enSuppliers from './locales/en/suppliers.json'
import enTerminals from './locales/en/terminals.json'
import enTutorials from './locales/en/tutorials.json'
export const defaultNS = 'common'
export const resources = {
  en: {
    common: enCommon,
    analytics: enAnalytics,
    auth: enAuth,
    balance: enBalance,
    bills: enBills,
    customers: enCustomers,
    disputes: enDisputes,
    invoices: enInvoices,
    notifications: enNotifications,
    payments: enPayments,
    refunds: enRefunds,
    rooms: enRooms,
    settings: enSettings,
    shops: enShops,
    suppliers: enSuppliers,
    terminals: enTerminals,
    tutorials: enTutorials,
  },
} as const
void i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  defaultNS,
  ns: Object.keys(resources.en),
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
})
export default i18n
